import Vue from 'vue'
import VueBarcode from 'vue-barcode'

Vue.component('barcode', VueBarcode)
